import {defineStore} from "pinia";

const useTrackStore = defineStore({
    id: "track",
    state: () => {
        return {
            song: {
                id: ''
            },
            musicList: [],
        }
    },
    actions: {
        setMusic(data) {
            this.song.id = data.rid
            let index = this.musicList.findIndex(i => {
                return i.rid == data.rid
            })
            if (index !== -1) {
                this.musicList.splice(index, 1);
                this.musicList.unshift(data);
            } else {
                this.musicList.unshift(data);
            }
        },
        setNowSong(id) {
            this.song.id = id
        },
        RemoveMusicList() {
            this.song.id = ''
            this.musicList = []
        },
        addMusic(list) {
            this.musicList = list
        },
        addMusicList(list){
            list.forEach(item=>{
                let index = this.musicList.findIndex(i => {
                    return i.rid == item.rid
                })
                if (index !== -1) {
                    this.musicList.splice(index, 1);
                }
            })
            this.musicList = list.concat(this.musicList)
        },
        addMusicListItem(item){
            this.musicList.push(item)
        },
        deleteSongItem(data) {
            if (data.rid == this.song.id) {
                if (this.musicList.length == 0) return
                let index = this.musicList.map(item=>item.rid).indexOf(this.song.id)
                index += 1
                if (index == this.musicList.length) index = 0
                this.setNowSong(this.musicList[index].rid)
            }
            this.musicList.map((item, index) => {
                if (item.rid == data.rid) {
                    this.musicList.splice(index, 1);
                    if (this.musicList.length == 0) {
                        this.song.id = ''
                    }
                }
            });
        },
    },
    getters: {},
    persist: {
        enabled: true,
        strategies: [
            {storage: localStorage, paths: ['song',  'musicList']},
        ],
    },
})

export default useTrackStore
